import { MotorStatusMdl } from './MotorStatusMdl';
export class QuoteBindMdl
{
  public makeList: Array<QuoteMakeMdl>=new Array<QuoteMakeMdl>();
  public modelList: Array<QuoteModelMdl>=new Array<QuoteModelMdl>();
  public cityList: Array<QuoteCityMdl>=new Array<QuoteCityMdl>(); 
  public usageList:Array<QuoteVehcielUsageMaster>=new Array<QuoteVehcielUsageMaster>();
 public st:MotorStatusMdl=new  MotorStatusMdl();
 
}

export class QuoteMakeMdl
{
  public MakeCode: string;
  public MakeDescEn: string;
  public MakeDescAr: string;     
}

export class QuoteModelMdl
{
    public ModelCode: string;
    public  ModelDescEn: string;
    public ModelDescAr: string;
    public MakeCode: string;     
}
export class QuoteVehcielUsageMaster
{
   public  VehUsagecode: number;
   public  VehUsage_DescEn: string;
   public Vehusage_DescAr: string;
}
export class QuoteCityMdl
{
    public CIT_CODE: number;
    public NAME: string;
    public  NAME_Ar: string;
    public RegionCode: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/QuoteBindMdl.ts